import { useRef, useState } from "react";

import { useBudgetContext } from "Hooks/useBudgetContext";
import { useProducts } from "Hooks/useProducts";

import { Button } from "Components/Button";
import { OverlayInputText } from "Components/Form/OverlayInputText";

import { OverlayProductList } from "../OverlayProductList";
import { Container } from "./styles";
import { ProductsFilterState } from "../interface";

interface InputOverlayListProps {
  handleTypeSearch: (search: string) => void;
  handleSearchProducts: () => void;
  filters: ProductsFilterState;
}

export const InputOverlayProductList = ({
  handleTypeSearch,
  handleSearchProducts,
  filters,
}: InputOverlayListProps) => {
  const [overlayOpen, setOverlayOpen] = useState<null | boolean>(null);
  const timeout = useRef<NodeJS.Timeout | null>(null);

  const hasAnyFilter = filters.services.length >= 1 || filters.status_id;

  const {
    selectedCovenant,
    zipCode,
    isCovenantBudget,
    budget,
    productsCategoriesSelected,
  } = useBudgetContext();

  const { productsList, loadingProducts, setProductFilters, enableData } =
    useProducts({
      enableReq: false,
      initialFilters: {},
    });

  const toggleOverlay = (status: boolean) => {
    if (!filters.search) setProductFilters({});
    setOverlayOpen(status);
    if (timeout.current) clearInterval(timeout.current);
  };

  const isHomeCollect = zipCode || budget?.zip_code;

  const handleDebounce = (search: string) => {
    setProductFilters({
      search,
      categories: productsCategoriesSelected?.join(","),
      plan_id: isCovenantBudget ? selectedCovenant?.covenant_plan.id : "",
      services: Array.isArray(filters.services)
        ? filters.services?.map((service) => service.id).join(",")
        : "",
      zip_code: zipCode || "",
      ...(selectedCovenant && {
        collect_type: isHomeCollect ? "home_collect" : "unity_collect",
      }),
    });
    enableData();
  };

  const handleType = (typeSearch: string) => {
    handleTypeSearch(typeSearch);

    if (timeout.current) clearInterval(timeout.current);

    timeout.current = setTimeout(() => {
      handleDebounce(typeSearch);
    }, 2000);
  };

  return (
    <Container>
      <OverlayInputText
        name="searchProducts"
        type="search"
        searchValue={filters.search}
        placeholder="Buscar por nome, código, ou sinônimo"
        onChange={(searchText) => handleType(searchText)}
        setOverlayOpen={toggleOverlay}
        isOverlayOpen={overlayOpen}
        disabled={!hasAnyFilter}
      >
        <Button
          transparentHover
          classButton="search-btn"
          onClick={handleSearchProducts}
        >
          {" "}
          Buscar
        </Button>
      </OverlayInputText>

      {overlayOpen && (
        <OverlayProductList
          loadingProducts={loadingProducts}
          productsList={productsList}
          hasSearched={!!filters.search}
        />
      )}
    </Container>
  );
};
